// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Hidden, makeStyles} from '@material-ui/core';

import LoadingSpinner from '../../../../elements/LoadingSpinner/LoadingSpinner';
import SnackBar from '../../../../elements/SnackBar/SnackBar';

import ProductSalesSection from './Sections/ProductSalesSection';
import LiveViewsSection from './Sections/LiveViewsSection';
import CallToActionSection from './Sections/CallToActionSection';
import SizeGuideSection from './Sections/SizeGuideSection';

import {usePage} from '../../../page/utils';
import BackSectionButton from '../../../../elements/BackSectionButton/BackSectionButton';

import type {ProductPageSettingRequest} from '../api';
import type {StoreProductSetting} from '../../../ui/duck';
import type {ProductPageSetting} from '../duck';
import type {Theme} from '@material-ui/core';

type Props = {
  productSetting?: StoreProductSetting,
  saveProductSetting: () => void,
  saveProductPageSetting: ({
    productPageSettingRequest: ProductPageSettingRequest,
  }) => void,
  isSavingProductSetting?: boolean,
  saveProductSettingSuccess?: boolean,
  saveProductSettingError?: boolean,
  errorProductSetting?: string,
  isFetchingProductPageSetting?: boolean,
  productPageSetting?: ProductPageSetting,
  isSavingProductPageSetting?: boolean,
  saveProductPageSettingError?: string,
  saveProductPageSettingSuccess?: boolean,
  // fetchSizeCharts: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default usePage<Props>(
  ProductPageConfiguration,
  'Product page configuration'
);

function ProductPageConfiguration(props: Props) {
  const {
    productSetting,
    saveProductSetting,
    isSavingProductSetting,
    saveProductSettingSuccess,
    saveProductSettingError,
    isFetchingProductPageSetting,
    productPageSetting,
    saveProductPageSettingSuccess,
    saveProductPageSetting,
    isSavingProductPageSetting,
    saveProductPageSettingError,
    // errorProductSetting,
    // fetchSizeCharts,
  } = props;
  const classes = useStyles();

  // useEffect(() => {
  //   fetchSizeCharts();
  // }, [fetchSizeCharts]);

  const messageSuccess =
    saveProductSettingSuccess || saveProductPageSettingSuccess;
  const messageError = saveProductSettingError || saveProductPageSettingError;

  return (
    <div className={classes.root}>
      {(isSavingProductSetting ||
        isFetchingProductPageSetting ||
        isSavingProductPageSetting) && <LoadingSpinner />}
      <SnackBar
        mode="success"
        message={!!messageSuccess ? 'Se guardaron los cambios' : undefined}
      />
      <SnackBar
        mode="error"
        message={!!messageError ? 'No se pudo guardar los cambios.' : undefined}
      />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Hidden smDown>
            <BackSectionButton
              to="/my-store/pages"
              label="Página de producto"
            />
          </Hidden>
        </Grid>
        <Grid item xs={12}>
          <LiveViewsSection
            productSetting={productSetting}
            saveProductSetting={saveProductSetting}
            disabled={isSavingProductSetting}
          />
        </Grid>
        <Grid item xs={12}>
          <ProductSalesSection
            productSetting={productSetting}
            saveProductSetting={saveProductSetting}
            disabled={isSavingProductSetting}
          />
        </Grid>
        <Grid item xs={12}>
          <SizeGuideSection
            saveProductPageSetting={saveProductPageSetting}
            productPageSetting={productPageSetting}
            disabled={isSavingProductPageSetting}
          />
        </Grid>
        <Grid item xs={12}>
          <CallToActionSection
            saveProductPageSetting={saveProductPageSetting}
            productPageSetting={productPageSetting}
            disabled={isSavingProductPageSetting}
          />
        </Grid>
      </Grid>
    </div>
  );
}

ProductPageConfiguration.propTypes = {
  productSetting: PropTypes.object,
  saveProductSetting: PropTypes.func.isRequired,
  isSavingProductSetting: PropTypes.bool,
  saveProductSettingSuccess: PropTypes.bool,
  saveProductSettingError: PropTypes.bool,
  errorProductSetting: PropTypes.string,
  isFetchingProductPageSetting: PropTypes.bool,
  productPageSetting: PropTypes.object,
  saveProductPageSetting: PropTypes.func.isRequired,
  isSavingProductPageSetting: PropTypes.bool,
  saveProductPageSettingError: PropTypes.string,
  saveProductPageSettingSuccess: PropTypes.bool,
  // fetchSizeCharts: PropTypes.func.isRequired,
};
